module.exports = __webpack_public_path__ + "img/logo_pt.95e85011.svg";